import type { Session } from '@halo/chat-sdk-react';
import { MessageReply } from '@halo/ui-chat-react';
import { useMsg, useUserInfo } from '@/scripts/hooks';
import { useStaticSessionStore } from '@/store/client';
import { hexToRgb } from '../ChatContent/helpers';
import { MsgsReplyItem } from '../messages/msgs-reply-item';

export interface MessageReplyWithDataProps {
  session: Session;
  link_msg_id: string;
}

export const MsgReply = memo(function MsgReply({
  session,
  link_msg_id,
}: MessageReplyWithDataProps) {
  const sessionStore = useStaticSessionStore(session.chat_id);

  const {
    msg: replyMsg,
    loading,
    isDeleted,
  } = useMsg({
    sessionId: session.chat_id,
    cliMsgId: link_msg_id,
  });

  const { user } = useUserInfo(replyMsg?.owner_id);

  const replyColor = useMemo(() => {
    const baseColor = user?.avatar_color || '#703EFF';
    const color = hexToRgb(baseColor);
    return {
      borderColor: baseColor,
      bgContentColor: `rgba(${color.r}, ${color.g}, ${color.b}, 0.1)`,
    };
  }, [user?.avatar_color]);

  return (
    <MessageReply
      borderColor={replyColor.borderColor}
      bgContentColor={replyColor.bgContentColor}
      user={user}
      loading={loading}
      isDeleted={isDeleted}
      msg={replyMsg}
      onClick={() => {
        if (replyMsg) {
          sessionStore?.scrollToMessage(replyMsg, true);
        }
      }}
    >
      <MsgsReplyItem session={session} message={replyMsg} />
    </MessageReply>
  );
});
